$('.withEveryPurchaseSlider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    swipe: false,
    dots: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                swipe: true
            }
        }
    ]
}).slickAnimation();


$('.withEveryPurchaseSlider').on('beforeChange', function(event, slick, currentSlide, nextSlide){

    $('.withEveryPurchaseSliderNavList li').each(function () {

        $(this).removeClass('activeEveryPurchaseSlide');

    });

    $('.withEveryPurchaseSliderNavList li[data-number='+ nextSlide +']').addClass('activeEveryPurchaseSlide');

    $('.currentSlideWithEveryPurchase').empty().append(nextSlide + 1);

});


$('.withEveryPurchaseSliderNavList li').on( 'click' , function () {

    var currentSlideNumber = $(this).attr('data-number');

    $('.withEveryPurchaseSlider').slick( 'slickGoTo' , currentSlideNumber );

});


$('.withEveryPurchaseNextSlide').on( 'click' , function () {

    $('.withEveryPurchaseSlider').slick( 'slickNext' );

});


// SCROLL TO TOP JS
$('.footerBackToTop').on('click', function (e) {
    e.preventDefault();
    $('html,body').animate({
        scrollTop: 0
    }, 700);
});




if ( $(window).width() <= 767 ) {
    // Mobile menu
    $('.mobileMenuButton').on('click', function() {
        $(this).toggleClass('active');


        if($(this).hasClass('active')) {
            $('.headerMenuStyle').addClass('fadeIn animated mainMenuVisible');
            $('body').css('overflow' , 'hidden');
        } else {
            $('.headerMenuStyle').removeClass('fadeIn');
            $('.headerMenuStyle').addClass('fadeOut');
            $('.headerMenuStyle').addClass('fadeMenuAnimation');
            setTimeout(function () {
                $('.headerMenuStyle').removeClass('mainMenuVisible');
                $('.headerMenuStyle').removeClass('fadeOut');
                $('.headerMenuStyle').removeClass('fadeMenuAnimation');
            }, 200);
            $('body').css('overflow' , 'initial');
        }

        $('html, body').toggleClass('fixedSroll');

    });

}


// SLide down
$(".scrollBottom").click(function() {
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".firstLookPart").offset().top
    }, 1500);
});